<template>
  <v-dialog :value="state.open" max-width="460" @input="closed">
    <div v-if="state.open" class="pb-dialog ch" role="alertdialog" aria-modal="true" aria-labelledby="ch-question"
         :aria-describedby="parts.body ? 'ch-detail' : null">
      <h2 id="ch-question" class="ch-question">{{ parts.question }}</h2>
      <p v-if="parts.body" id="ch-detail" class="pb-body ch-detail">{{ parts.body }}</p>
      <div class="pb-dialog-actions">
        <button type="button" class="pb-button ghost" @click="answer(false)">Cancel</button>
        <button ref="go" type="button" :class="['pb-button', state.tone]" @click="answer(true)">{{ state.action }}</button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { answer, confirmState } from '../lib/confirm';

export default {
  name: 'ConfirmHost',
  computed: {
    state() { return confirmState; },
    parts() {
      const match = this.state.text.match(/^(.+?[.?!])\s+(.+)$/);
      return match ? { question: match[1], body: match[2] } : { question: this.state.text, body: '' };
    }
  },
  watch: {
    'state.open'(open) { if (open) this.$nextTick(() => { if (this.$refs.go) this.$refs.go.focus(); }); }
  },
  methods: {
    answer,
    closed(open) { if (!open) answer(false); }
  }
};
</script>

<style scoped>
.ch-question{margin:0;font:500 22px/1.3 var(--font-display)!important;color:#1F2328}
.ch-detail{margin:10px 0 0;color:#4F4A45}
</style>
